import actionTypes from '../../action-types'

export default (payload, meta, included) => ({
  type: actionTypes.USERS.SET_ALL,
  payload,
  meta,
  included,
})
